import type { MbcBrief } from "@nlc/shared-types";

import type { MBCReviewData } from "./types";

export function mapBriefToReview(
  brief: MbcBrief | null,
  designTypeName = "",
): MBCReviewData {
  return {
    brief: {
      fileSizes: (brief?.fileSizes ?? []).map((size) => ({
        label: size.label ?? "",
        size: size.dimensions ?? "",
      })),
      fileTypes: brief?.fileTypes ?? [],
      textForDesign: brief?.textForDesign ?? "",
      title: brief?.title ?? "",
      typeTag: designTypeName,
      visualDirection: brief?.visualDirection ?? "",
    },
  };
}
